import { useEffect, useState } from 'react'
import ContentHeader from '../components/ContentHeader'
import CoreMemory from '../components/CoreMemory'
import { getSessionAuth } from '../utils/sessionAuth'
import { ensureSessionUserId, getSessionUserId } from '../utils/sessionUser'
import '../style/views/MemoriesView.css'

function MemoriesView() {
  const [userId, setUserId] = useState<string | null>(() => getSessionUserId())

  useEffect(() => {
    if (!userId) {
      ensureSessionUserId(getSessionAuth()).then((id) => {
        if (id) setUserId(id)
      })
    }
  }, [userId])

  return (
    <>
      <ContentHeader title="Core Memory" />
      <div className="content-panel">
        {userId ? (
          <CoreMemory userId={userId} />
        ) : (
          <p className="muted">Loading…</p>
        )}
      </div>
    </>
  )
}

export default MemoriesView
